import currentChainAtom from './atom';

export default currentChainAtom;
